import React from 'react'
import { useLocation } from 'react-router-dom'

import Sidebar from 'src/layouts/Sidebar'
import Navbar from 'src/layouts/Navbar'
import Container from 'src/layouts/Container'
import Footer from 'src/layouts/Footer'
import PromotionBanner from 'src/layouts/PromotionBanner'

interface IProps {
  hasBanner?: boolean
  hasNavbar?: boolean
  hasSidebar?: boolean
  hasFooter?: boolean
  children: React.ReactNode
}

const App = (props: IProps) => {
  const location = useLocation()
  const isHome = location.pathname === '/' || location.pathname === '/home'
  const isLogout = location.pathname.startsWith('/logout')

  return (
    <>
      {props.hasNavbar && !isHome && !isLogout && <Navbar />}
      {props.hasSidebar && <Sidebar />}
      <Container>{props.children}</Container>
      {props.hasFooter && !isHome && <Footer />}
    </>
  )
}

export default App
